import React from 'react';
import clsx from 'clsx';

const colorClasses = {
  primary:   'bg-primary-500',
  secondary: 'bg-secondary-500',
  success:   'bg-success-500',
  warning:   'bg-warning-500',
  error:     'bg-error-500',
  accent:    'bg-accent-500',
  neutral:   'bg-neutral-500',
};

export default function ProgressBar({
  value = 0,
  color = 'primary',
  label,
  showValue = false,
  className,
}) {
  const clamped = Math.min(100, Math.max(0, value));
  const barColor = colorClasses[color] ?? colorClasses.primary;

  return (
    <div className={clsx('w-full', className)}>
      {(label || showValue) && (
        <div className="mb-1.5 flex items-center justify-between gap-2">
          {label && (
            <span className="text-sm font-medium text-neutral-700">{label}</span>
          )}
          {showValue && (
            <span className="text-sm font-medium text-neutral-500">
              {clamped}%
            </span>
          )}
        </div>
      )}
      <div className="h-2 w-full overflow-hidden rounded-full bg-neutral-100">
        <div
          className={clsx('h-full rounded-full transition-all duration-500 ease-out', barColor)}
          style={{ width: `${clamped}%` }}
          role="progressbar"
          aria-valuenow={clamped}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
}
